<template>
  <div class="carousel-block">
    <div class="carousel-block__carousel">
      <div class="carousel-block__tape-wrapper">
        <draggable
          filter=".carousel-block__new-card"
          class="carousel-block__tape"
          :list="val.cards"
          direction="horizontal"
          @end="endDrag"
        >
          <message-generic-card
            class="carousel-block__card"
            v-for="(card, index) in val.cards"
            :key="card.uuid"
            v-model="val.cards[index]"
            ref="cardsElements"
            :aspectRatio="val.aspectRatio"
            :lastZIndex="lastZIndex"
            @input="onInput"
            @remove="cardDelete"
            @loading="$emit('loading')"
            @loadingEnd="$emit('loadingEnd')"
            @popoverOpen="lastZIndex++"
          ></message-generic-card>

          <div class="carousel-block__new-card" @click="addCard" v-if="val.cards.length < 10">
            <div>
              <fai class="carousel-block__new-card-icon" size="3x" icon="plus"></fai>
              <div
                class="carousel-block__new-card-text"
              >{{ $t('view.flow.block.carousel.addCard') }}</div>
            </div>
          </div>
        </draggable>
      </div>
    </div>
    <sw-button
      class="carousel-block__switch"
      v-model="aspectRatioBool"
      :label="$t('view.flow.block.carousel.aspectRatio')"
      :onText="$t('view.flow.block.carousel.squareAR')"
      :offText="$t('view.flow.block.carousel.horizontalAR')"
      alwaysActive
      @input="onInput"
    ></sw-button>
  </div>
</template>

<script>
import axios from '@/axios'
export default {
  data () {
    return {
      val: null,
      aspectRatioBool: false,
      lastZIndex: 1,
      elements: {
        card: {
          title: {},
          subtitle: {},
          image_url: '',
          buttons: [],
          default_url: ''
        }
      }
    }
  },
  watch: {
    aspectRatioBool: function (act, old) {
      if (act) this.val.aspectRatio = 'square'
      else this.val.aspectRatio = 'horizontal'
    }
  },
  props: ['value', 'blockId'],
  created () {
    this.val = this.value
    if (this.val.aspectRatio === 'horizontal') this.aspectRatioBool = false
    else this.aspectRatioBool = true
  },
  methods: {
    onInput () {
      this.$emit('input', this.val)
      this.$store.commit('SET_FLOW_EDIT_FLAG', [this.blockId, true])
      this.$store.commit('SET_EDITED', true)
    },

    addCard () {
      let el = JSON.parse(JSON.stringify(this.elements.card))
      el.uuid = this.uid()
      for (let locale in this.$store.state.flowLocales) {
        el.title[locale] = this.$t('view.flow.block.carousel.cardTitle')
        el.subtitle[locale] = this.$t('view.flow.block.carousel.cardSubtitle')
      }
      this.val.cards.push(el)
      this.onInput()
    },

    cardDelete (uid) {
      let i = 0
      for (let card of this.val.cards) {
        if (card.uuid === uid) {
          this.val.cards.splice(i, 1)
          this.$store.commit('SET_FLOW_EDIT_FLAG', [this.blockId, true])
          break
        }
        i++
      }
    },

    async uploadToS3 (file, url) {
      try {
        const options = {
          headers: {
            'Content-Type': file.type,
            'x-amz-acl': 'public-read'
          }
        }
        const uploadReq = await axios.put(url, file, options)
        return uploadReq.request.responseURL.replace(/\?.*$/, '')
      } catch (e) {
        throw e
      }
    },

    async beforeSave () {
      try {
        let param = ''
        let firstElement = true
        for (let card of this.$refs.cardsElements) {
          if (card.image.file) {
            if (!firstElement) param += ','
            param += card.image.file.type
            firstElement = false
          }
        }

        if (!param.length) return

        const signedUrlsReq = await axios.get('/api/flow/carousel-upload-urls?elements=' + param)
        const uploadUrls = signedUrlsReq.data.urls

        let o = 0
        for (let card of this.$refs.cardsElements) {
          if (!card.image.file) continue
          const uploaded = await this.uploadToS3(card.image.file, uploadUrls[o])
          card.setImageUrl(uploaded)
          o++
        }
      } catch (e) {
        throw e
      }
    },

    endDrag (event) {
      if (event.oldIndex !== event.newIndex) {
        this.$store.commit('SET_FLOW_EDIT_FLAG', [this.blockId, true])
        this.$store.commit('SET_EDITED', true)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.carousel-block {
  max-width: 88%;
  margin-right: 0px;

  &__tape {
    @include alignedFlex(flex-start);
    display: inline-flex;
    align-items: stretch;
  }

  &__tape-wrapper {
    overflow-y: auto;
    width: 100%;
    padding: 10px;
  }

  &__card {
    flex-basis: 0;
    margin-right: 12px;
  }

  &__new-card {
    @include alignedFlex();
    flex-basis: 0;
    min-width: 270px;
    text-align: center;
    background-color: white;
    color: rgba(0, 0, 0, 0.4);
    border-radius: 7px;
    min-height: 240px;
    cursor: pointer;

    & > div {
      transition: transform 0.2s ease;
    }

    &:hover {
      & > div {
        transform: scale(1.05);
      }
    }
  }

  &__new-card-text {
    font-size: 1.5em;
    margin-top: 8px;
  }

  &__switch {
    margin-top: 12px;
  }
}
</style>
